import React, { Component } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import icon_reportDetail_head from "../../images/icon_reportDetail_head.png"
import './index.css'

type StateProps = {
	static: any
}

class StaticFeetData extends Component<StateProps & WithTranslation> {

	getStaticData() {
		const staticLeft = this.props.static.left
		const staticRight = this.props.static.right

		let anterior: any = {
			left: {},
			right: {},
			anteriorBothRatioLeft: 0,
			anteriorWholeRatioLeft: 0,
			anteriorBothRatioRight: 0,
			anteriorWholeRatioRight: 0,
			weightRatioLeft: 0,
			weightRatioRight: 0
		}

		let posterior: any = {
			left: {},
			right: {},
			posteriorBothRatioLeft: 0,
			posteriorWholeRatioLeft: 0,
			posteriorBothRatioRight: 0,
			posteriorWholeRatioRight: 0,
			weightRatioLeft: 0,
			weightRatioRight: 0
		}

		anterior.left = staticLeft.anterior
		posterior.left = staticLeft.posterior
		anterior.right = staticRight.anterior
		posterior.right = staticRight.posterior
		const i18n = this.props.i18n;

		const leftAnterior: any = [
			{ name: `${i18n.t('area')}【mm²】`, data: anterior.left.area },
			{ name: `${i18n.t('front/feet')}【%】`, data: anterior.left.loadOverBothSide * 100 },
			{ name: `${i18n.t('front/wholeFoot')}【%】`, data: anterior.left.loadOverSelfSide * 100 },
			{ name: `${i18n.t('maxPressure')}【kPa(r)】`, data: anterior.left.pressureMax  / 1000 },
			{ name: `${i18n.t('averagePressure')}【kPa(r)】`, data: anterior.left.pressureMean  / 1000 },
		]

		const rightAnterior: any = [
			{ name: `${i18n.t('area')}【mm²】`, data: anterior.right.area },
			{ name: `${i18n.t('front/feet')}【%】`, data: anterior.right.loadOverBothSide * 100 },
			{ name: `${i18n.t('front/wholeFoot')}【%】`, data: anterior.right.loadOverSelfSide * 100 },
			{ name: `${i18n.t('maxPressure')}【kPa(r)】`, data: anterior.right.pressureMax / 1000 },
			{ name: `${i18n.t('averagePressure')}【kPa(r)】`, data: anterior.right.pressureMean / 1000 },
		]

		const leftPosterior: any = [
			{ name: `${i18n.t('area')}【mm²】`, data: posterior.left.area },
			{ name: `${i18n.t('back/feet')}【%】`, data: posterior.left.loadOverBothSide * 100 },
			{ name: `${i18n.t('back/wholeFoot')}【%】`, data: posterior.left.loadOverSelfSide * 100 },
			{ name: `${i18n.t('maxPressure')}【kPa(r)】`, data: posterior.left.pressureMax  / 1000 },
			{ name: `${i18n.t('averagePressure')}【kPa(r)】`, data: posterior.left.pressureMean  / 1000 },
		]

		const rightPosterior: any = [
			{ name: `${i18n.t('area')}【mm²】`, data: posterior.right.area },
			{ name: `${i18n.t('back/feet')}【%】`, data: posterior.right.loadOverBothSide * 100 },
			{ name: `${i18n.t('back/wholeFoot')}【%】`, data: posterior.right.loadOverSelfSide * 100 },
			{ name: `${i18n.t('maxPressure')}【kPa(r)】`, data: posterior.right.pressureMax / 1000},
			{ name: `${i18n.t('averagePressure')}【kPa(r)】`, data: posterior.right.pressureMean / 1000 },
		]

		return {
			leftAnterior,
			rightAnterior,
			leftPosterior,
			rightPosterior,
		}
		
	}


	returnText = (leftAnterior, leftPosterior, rightAnterior, rightPosterior) => {
		const i18n = this.props.i18n;
		let areaMaxLeftRight = i18n.t("staticFootDataAnalyLeft");
		let areaMaxForeHind = i18n.t("staticFootDataAnalyFore");
		let areaMax = leftAnterior[0].data;
		if (leftPosterior[0].data > areaMax) {
			areaMax = leftPosterior[0].data;
			areaMaxForeHind = i18n.t("staticFootDataAnalyHind");
		}
		if (rightAnterior[0].data > areaMax) {
			areaMax = rightAnterior[0].data;
			areaMaxLeftRight = i18n.t("staticFootDataAnalyRight");
			areaMaxForeHind = i18n.t("staticFootDataAnalyFore");
		}
		if (rightPosterior[0].data > areaMax) {
			areaMaxLeftRight = i18n.t("staticFootDataAnalyRight");
			areaMaxForeHind = i18n.t("staticFootDataAnalyHind");
		}

		let areaMinLeftRight = i18n.t("staticFootDataAnalyLeft");
		let areaMinForeHind = i18n.t("staticFootDataAnalyFore");
		let areaMin = leftAnterior[0].data;
		if (leftPosterior[0].data < areaMin) {
			areaMin = leftPosterior[0].data;
			areaMinForeHind = i18n.t("staticFootDataAnalyHind");
		}
		if (rightAnterior[0].data < areaMin) {
			areaMin = rightAnterior[0].data;
			areaMinLeftRight = i18n.t("staticFootDataAnalyRight");
			areaMinForeHind = i18n.t("staticFootDataAnalyFore");
		}
		if (rightPosterior[0].data < areaMin) {
			areaMinLeftRight = i18n.t("staticFootDataAnalyRight");
			areaMinForeHind = i18n.t("staticFootDataAnalyHind");
		}

		let averagePressureLeftRight = i18n.t("staticFootDataAnalyLeft");
		let averagePressureForeHind = i18n.t("staticFootDataAnalyFore");
		let pressureAve = leftAnterior[4].data;
		if (leftPosterior[4].data > pressureAve) {
			pressureAve = leftPosterior[4].data;
			averagePressureForeHind = i18n.t("staticFootDataAnalyHind");
		}
		if (rightAnterior[4].data > pressureAve) {
			averagePressureLeftRight = i18n.t("staticFootDataAnalyRight");
			averagePressureForeHind = i18n.t("staticFootDataAnalyFore");
		}
		if (rightPosterior[4].data > pressureAve) {
			averagePressureLeftRight = i18n.t("staticFootDataAnalyRight");
			averagePressureForeHind = i18n.t("staticFootDataAnalyHind");
		}

		let maxPressureLeftRight = i18n.t("staticFootDataAnalyLeft");
		let maxPressureForeHind = i18n.t("staticFootDataAnalyFore");
		let pressureMax = leftAnterior[3].data;
		if (leftPosterior[3].data > pressureMax) {
			pressureMax = leftPosterior[3].data;
			maxPressureForeHind = i18n.t("staticFootDataAnalyHind");
		}
		if (rightAnterior[3].data > pressureMax) {
			pressureMax = rightAnterior[3].data;
			maxPressureLeftRight = i18n.t("staticFootDataAnalyRight");
			maxPressureForeHind = i18n.t("staticFootDataAnalyFore");
		}
		if (rightPosterior[3].data > pressureMax) {
			maxPressureLeftRight = i18n.t("staticFootDataAnalyRight");
			maxPressureForeHind = i18n.t("staticFootDataAnalyHind");
		}

		return i18n.t(
			"staticFootDataAnalyText",
			{
				areaMaxLeftRight,
				areaMaxForeHind,
				areaMinLeftRight,
				areaMinForeHind,
				averagePressureLeftRight,
				averagePressureForeHind,
				maxPressureLeftRight,
				maxPressureForeHind,
			}
		)

	}

	createPressureFigureCanvas(pressureFigure, footData) {
		if(!pressureFigure) return;
		const data = this.props.static;
		const staticLeft = data.left.thumbnail
		const staticRight = data.right.thumbnail
		const staticBody = data.thumbnail
		const cop = data.cop
		let wholeLeft = data.left.whole
    	let wholeRight = data.right.whole

		// let pressureFigure: any = document.getElementById('pressureFigure')
		let ctx = pressureFigure.getContext('2d')
		const staticImg = this.props.static.thumbnail.url

		const that = this;
		let img = new Image();
		img.crossOrigin = "anonymous";
		img.src = staticImg;
		img.onload = function () {
			const canvasWidth = 429, canvasHeight = 429
			const proportion = canvasWidth / staticLeft.width

			// 绘制图
			ctx.drawImage(img, 0, 0, canvasWidth, canvasHeight)

			// 绘制中心线
			ctx.strokeStyle = '#A3A3A3'
			that.drawLineDash(ctx, staticBody.centroidX, 0, staticBody.centroidX, canvasHeight, proportion)
			that.drawLineDash(ctx, 0, staticBody.centroidY, canvasWidth, staticBody.centroidY, proportion)

			// 绘制轨迹
			that.drawLocus(ctx, cop, proportion, staticBody.centroidX, staticBody.centroidY)

			// 绘制点
			ctx.fillStyle = '#FFF'
			that.drawPoint(ctx, staticLeft.copX, staticLeft.copY, proportion) // 左脚中心点
			that.drawPoint(ctx, staticBody.copX, staticBody.copY, proportion) // 中心点
			that.drawPoint(ctx, staticRight.copX, staticRight.copY, proportion) // 右脚中心点
			that.drawPoint(ctx, staticLeft.forceMaxPointX, staticLeft.forceMaxPointY, proportion) // 左脚最大值
			that.drawPoint(ctx, staticRight.forceMaxPointX, staticRight.forceMaxPointY, proportion) // 右脚中心点

			// 绘制文本
			that.drawText(ctx, 'L', staticLeft.copX, staticLeft.copY, proportion)
			that.drawText(ctx, 'C', staticBody.copX, staticBody.copY, proportion)
			that.drawText(ctx, 'R', staticRight.copX, staticRight.copY, proportion)
			that.drawText(ctx, 'M', staticLeft.forceMaxPointX, staticLeft.forceMaxPointY, proportion)
			that.drawText(ctx, 'M', staticRight.forceMaxPointX, staticRight.forceMaxPointY, proportion)

			// 绘制上下左右对比值 %
			const {
				leftAnterior, rightAnterior,
				leftPosterior, rightPosterior,
			} = footData;
			that.drawText(ctx, leftAnterior[2].data.toFixed(0) + "%", 5, staticBody.centroidY - 10, proportion);
			that.drawText(ctx, leftPosterior[2].data.toFixed(0) + "%", 5, staticBody.centroidY + 10, proportion);
			that.drawText(ctx, rightAnterior[2].data.toFixed(0) + "%", img.width - 18, staticBody.centroidY - 10, proportion);
			that.drawText(ctx, rightPosterior[2].data.toFixed(0) + "%", img.width - 18, staticBody.centroidY + 10, proportion);
			that.drawText(ctx, rightPosterior[2].data.toFixed(0) + "%", img.width - 18, staticBody.centroidY + 10, proportion);

			const topLeft = (wholeLeft.loadOverBothSide * 100).toFixed(0) + "%";
			const topRight = (wholeRight.loadOverBothSide * 100).toFixed(0) + "%";
			that.drawText(ctx, topLeft, staticBody.centroidX - 28, 30, proportion);
			that.drawText(ctx, topRight, staticBody.centroidX + 18, 30, proportion);

		}
	}

	drawPoint(ctx: any, x: number, y: number, proportion: number) {
		ctx.translate(0, 0)
		ctx.beginPath()
		ctx.arc(x * proportion, y * proportion, 10, 0, 2 * Math.PI) // 左脚中心点
		ctx.fill()
	}

	drawLineDash(ctx: any, x1: number, y1: number, x2: number, y2: number, proportion: number) {
		ctx.beginPath()
		ctx.setLineDash([3, 5])
		ctx.lineWidth = 2
		ctx.moveTo(x1 * proportion, y1 * proportion)
		ctx.lineTo(x2 * proportion, y2 * proportion)
		ctx.closePath()
		ctx.stroke()
	}

	drawText(ctx: any, text: string, x: number, y: number, proportion: number) {
		ctx.translate(0, 0)
		ctx.fillStyle = '#000'
		ctx.font = '15px MicrosoftYaHei'
		ctx.fillText(text, (x * proportion) - 5, (y * proportion) + 5)
	}

	drawLocus(ctx: any, cop: any, proportion: number, centroidX: number, centroidY: number) {
		ctx.save()
		ctx.translate(centroidX * proportion, centroidY * proportion)
		ctx.beginPath()
		ctx.setLineDash([])
		ctx.strokeStyle = "#00ACC1"
		let points: any[] = []
		for (let i = 0; i < cop.x.length; i++) {
			// let phys = cop.physicalHeight / staticBody.height;
			points.push([cop.x[i] * proportion, cop.y[i] * proportion])
		}

		ctx.moveTo(points[0][0], -points[0][1])
		for (let i = 1; i < points.length; i++) {
			ctx.lineTo(points[i][0], -points[i][1])
		}
		ctx.closePath()
		ctx.stroke()
		ctx.restore()
	}

	render() {

		const {
			leftAnterior, leftPosterior, 
			rightAnterior, rightPosterior
		} = this.getStaticData();
		const text = this.returnText(
			leftAnterior, leftPosterior, 
			rightAnterior, rightPosterior
			);
		const i18n = this.props.i18n;

		return (
			<div className="standing-feet-data">
				<p className="reportCom-container-title">
						{/* <img src={icon_reportDetail_head} alt="icon head" /> */}
						<span>{i18n.t('staticFootData')}</span>
					</p>
					<div className="standing-feet-data-detail">
						{/* 左脚数据 */}
						<div className="standing-feet-data-left">
							<div className="standing-feet-data-btn">{i18n.t('leftForeFoot')}</div>
							<div className="standing-feet-data-before">
								{leftAnterior.length && leftAnterior.map((item: any, index: any) => {
									let value = item.data.toFixed(0);
									if(index > 2) {
										value = item.data.toFixed(3)
									}
									return (
										<div key={item.name}>
											<span>{item.name}</span>
											<span>{value}</span>
										</div>
									)
								})}
							</div>
							<div className="standing-feet-data-btn">{i18n.t('leftHindFoot')}</div>
							<div className="standing-feet-data-after">
								{leftPosterior.length && leftPosterior.map((item, index) => {
									let value = item.data.toFixed(0);
									if(index > 2) {
										value = item.data.toFixed(3)
									}
									return (
										<div key={item.name}>
											<span>{item.name}</span>
											<span>{value}</span>
										</div>
									)
								})}
							</div>
						</div>
						{/* 压力图 */}
						<div className="pressure-figure-box">
							<div className="pressure-figure">
								<canvas 
									id="pressureFigure" 
									className="prssure-figure-canvas" 
									width="429" 
									height="429"
									ref={ref => this.createPressureFigureCanvas(ref, 
										{
											leftAnterior,
											rightAnterior,
											leftPosterior,
											rightPosterior,
										}
									)}
									></canvas>
								{/* <img id="pressureFigureImg" src={staticImg} alt="" style={{ display: 'none' }} /> */}
							</div>
							<div className="pressure-figure-score">
								<span>min</span>
								<span>max</span>
							</div>
						</div>
						{/* 右脚数据 */}
						<div className="standing-feet-data-right">
							<div className="standing-feet-data-btn">{i18n.t('rightForeFoot')}</div>
							<div className="standing-feet-data-before">
								{rightAnterior.length && rightAnterior.map((item, index) => {
									let value = item.data.toFixed(0);
									if(index > 2) {
										value = item.data.toFixed(3)
									}
									return (
										<div key={item.name}>
											<span>{item.name}</span>
											<span>{value}</span>
										</div>
									)
								})}
							</div>
							<div className="standing-feet-data-btn">{i18n.t('rightHindFoot')}</div>
							<div className="standing-feet-data-after">
								{rightPosterior.length && rightPosterior.map((item, index) => {
									let value = item.data.toFixed(0);
									if(index > 2) {
										value = item.data.toFixed(3)
									}
									return (
										<div key={item.name}>
											<span>{item.name}</span>
											<span>{value}</span>
										</div>
									)
								})}
							</div>
						</div>
					</div>

					<p className="standing-feet-data-text">
						{text}
					</p>
			</div>
		)
	}
}

export default withTranslation()(StaticFeetData)